<div class="testimonial_area">
  <div class="container-fluid">
    <div class="row">
      <!-- YouTube Embed -->
      <div class="col-lg-4 col-md-6">
        <h3>Subscribe Us</h3>
        <hr>
        <iframe 
          width="100%" 
          height="370" 
          src="https://www.youtube.com/embed/VJQUNVJRGTU?si=3Gk8hNdpcXsYvbAM&amp;start=6" 
          title="YouTube video player" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
          referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
        </iframe>
      </div>

      <!-- Elfsight Follow Us -->
      <div class="col-lg-4 col-md-6">
        <h3>Follow Us</h3>
        <hr>
        <div #targetBtn class="elfsight-app-71285587-a53c-4e3e-a233-1ca31ab6a3da" data-elfsight-app-lazy></div>
        <!-- <div #followerDiv class="box3"></div> -->
      </div>

      <!-- FAQs Accordion -->
      <div class="col-lg-4 col-md-6">
        <h3>FAQs</h3>
        <hr>
        <div class="accordion accordion-flush" id="accordionFlushExample">

          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingOne">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne"
                aria-expanded="false" aria-controls="flush-collapseOne">
                What is Open Trip?
              </button>
            </h2>
            <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne"
              data-bs-parent="#accordionFlushExample">
              <div class="accordion-body">
                Open Trip is a shared Trip with other people in a group who may not know each other, with the same destination,
                and only available on certain days/dates, and certain boats.
              </div>
            </div>
          </div>

          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingTwo">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo"
                aria-expanded="false" aria-controls="flush-collapseTwo">
                What is Private Trip?
              </button>
            </h2>
            <div id="flush-collapseTwo" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo"
              data-bs-parent="#accordionFlushExample">
              <div class="accordion-body">
                Private Trip is a private holiday with your own group/colleagues. You can choose boats and dates according to your
                needs and wishes. We will try to adjust and accommodate all your needs.
              </div>
            </div>
          </div>

          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingThree">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree"
                aria-expanded="false" aria-controls="flush-collapseThree">
                Payment?
              </button>
            </h2>
            <div id="flush-collapseThree" class="accordion-collapse collapse" aria-labelledby="flush-headingThree"
              data-bs-parent="#accordionFlushExample">
              <div class="accordion-body">
                <p style="text-align: left;">PROCEDURES FOR REGISTRATION</p>
                <ul>
                  <li>Pay 30% Down Payment as a Commitment Fee for Private Charter and 50% for Open Trip.</li>
                  <li>For manual bookings, the down payment can be made by bank transfer, Wise, or Revolut.</li>
                  <li>For bookings made through our website using a credit card, full payment is required at the time of booking.</li>
                  <li>Confirm payment via email by attaching proof of transfer.</li>
                  <li>Full payment must be made no later than 14 days before the trip date.</li>
                  <li>Open Trip registration will close once the quota is full.</li>
                  <li>Payment can be transferred to: Mandiri Bank, Account No. 155-00-1-131-507-7, Account Name: CV. EAST INDONESIA TRIP.</li>
                </ul>
              </div>
            </div>
          </div>

          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingFour">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour"
                aria-expanded="false" aria-controls="flush-collapseFour">
                Cancellation?
              </button>
            </h2>
            <div id="flush-collapseFour" class="accordion-collapse collapse" aria-labelledby="flush-headingFour"
              data-bs-parent="#accordionFlushExample">
              <div class="accordion-body">
                <p style="text-align: left;">Due to the impact cancellations and amendments have on our operations, we must enforce the following policies:</p>
                <ul>
                  <li>2 month before trip: No refund.</li>
                  <li>2 - 4 month before trip: 30% of total booking cost will be refunded.</li>
                  <li>4+ month before trip: 50% of total booking cost will be refunded.</li>
                  <li>Special Cancellation Policy (0-14 days prior to trip): If you need to cancel due to critical illness, accident, or the death of an immediate family member, we will require proof (e.g., hospital letter, death certificate with matching passenger ID details). In this case, a 50% fee will apply. We reserve the right to verify the provided documentation before proceeding with the cancellation.</li>
                  <li>Force Majeure/Natural Disaster Policy: We are committed to providing the services and experiences as advertised. However, in the event of unforeseen circumstances beyond our control—such as a pandemic, civil unrest, industrial disputes, natural disasters, war, terrorist activities, floods, or fires—we reserve the right to modify, cancel, or limit the services provided.</li>
                  <li>In the event of a natural disaster or force majeure that directly impacts the trip location, we will review cancellations on a case-by-case basis. Please note that natural disasters outside the trip location do not qualify under this cancellation policy.</li>
                  <li>No-show Policy: If you fail to attend your trip for personal reasons, the booking will be considered canceled, and full payment will be required.</li>
                </ul>
                <p style="text-align: left;">We appreciate your understanding and cooperation in adhering to these policies to ensure smooth operations for all parties involved.</p>
                <p style="text-align: left;">REFUND POLICY</p>
                <ul>
                  <li>Refunds will be processed within a maximum of 14 business days (14 x 24 hours) after confirmation.</li>
                  <li>The refund will be issued in IDR (Indonesian Rupiah). Please note that any applicable administrative fees will be deducted from the refund balance.</li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
